import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { LogIn, ShieldCheck } from "lucide-react";
import { useLang } from "@/context/LangContext";
import BrandMark from "@/components/BrandMark";

export default function Login() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [ref, setRef] = useState(params.get("ref") || "");
  const { t } = useLang();

  useEffect(() => {
    if (ref) sessionStorage.setItem("sb_referral", ref);
  }, [ref]);

  const startGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="mx-auto max-w-md px-4 py-16">
      <div className="text-center mb-8 flex flex-col items-center">
        <BrandMark size={160} />
        <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground mt-2">
          {t("footer.brand_subtitle")}
        </p>
      </div>

      <Card className="p-8 border-border/60">
        <h1 className="font-heading text-2xl mb-1">{t("login.title")}</h1>
        <p className="text-sm text-muted-foreground mb-6">
          {t("login.intro")}
        </p>

        <label className="text-xs uppercase tracking-[0.16em] text-muted-foreground">
          {t("login.referral_label")}
        </label>
        <Input
          data-testid="login-referral-input"
          placeholder="SBXXXXXX"
          value={ref}
          onChange={(e) => setRef(e.target.value.toUpperCase().trim())}
          className="mt-2 mb-5"
        />

        <Button
          onClick={startGoogle}
          className="w-full rounded-full h-12"
          data-testid="login-google-btn"
        >
          <LogIn className="h-4 w-4 mr-2" /> {t("login.cta")}
        </Button>

        <div className="mt-6 p-3 rounded-xl bg-muted/60 text-xs text-muted-foreground flex gap-2">
          <ShieldCheck className="h-4 w-4 mt-0.5 shrink-0 text-primary" />
          <span>
            {t("login.notice")}
          </span>
        </div>

        <div className="mt-3 p-3 rounded-xl border border-primary/40 bg-primary/5 text-xs text-foreground">
          <span className="font-semibold text-primary">New here?</span>{" "}
          You must accept the community agreement first —{" "}
          <button
            type="button"
            onClick={() => navigate(`/register${ref ? `?ref=${encodeURIComponent(ref)}` : ""}`)}
            className="underline underline-offset-2 hover:text-primary"
            data-testid="login-goto-register"
          >
            open the sign-up page
          </button>
          .
        </div>

        <Button
          variant="link"
          className="w-full mt-4"
          onClick={() => navigate("/")}
          data-testid="login-back-btn"
        >
          {t("common.back_home")}
        </Button>
      </Card>
    </div>
  );
}
